import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-79f07c64")

_pushScopeId("data-v-79f07c64")
const _hoisted_1 = { class: "flex flex--width flex--v flex--valign-c flex--gap-20" }
const _hoisted_2 = { class: "text text--primary-b text--size-18 text--medium text--height-22 text--center" }
const _hoisted_3 = {
  key: 0,
  class: "text text--accent-gray-b text--size-16 text--semi-bold text--center"
}
const _hoisted_4 = { class: "flex flex--v flex--gap-20" }
const _hoisted_5 = { class: "flex flex--v flex--gap-5" }
const _hoisted_6 = {
  for: "email",
  class: "form-label"
}
const _hoisted_7 = { class: "flex flex--width flex--v flex--valign-c flex--gap-20" }
const _hoisted_8 = { class: "flex flex--v flex--valign-c flex--gap-10" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BreezeValidationErrors = _resolveComponent("BreezeValidationErrors")
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_InertiaLink = _resolveComponent("InertiaLink")
  const _component_Plane = _resolveComponent("Plane")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('auth.password_reset'),
    gap: false
  }, {
    default: _withId(() => [
      _createVNode(_component_Plane, {
        class: "login-plane",
        darker: true
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$trans("auth.forgot_password_text")), 1),
            _createVNode(_component_BreezeValidationErrors),
            (_ctx.status)
              ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.status), 1))
              : _createCommentVNode("", true),
            _createVNode("form", {
              class: "full-width",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$trans("auth.email")), 1),
                  _withDirectives(_createVNode("input", {
                    id: "email",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.email = $event)),
                    name: "email",
                    type: "email",
                    class: "form-control",
                    required: "",
                    autofocus: "",
                    autocomplete: "username"
                  }, null, 512), [
                    [_vModelText, _ctx.form.email]
                  ])
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_GenericButton, {
                    class: "login-button",
                    title: _ctx.$trans('auth.password_reset'),
                    disabled: _ctx.form.processing,
                    onClick: _ctx.submit
                  }, null, 8, ["title", "disabled", "onClick"]),
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_InertiaLink, {
                      href: _ctx.route('login'),
                      class: "inertia-link text text--less-gap text--primary-b text--size-16 text--center"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$trans("auth.login")), 1)
                      ]),
                      _: 1
                    }, 8, ["href"]),
                    _createVNode(_component_InertiaLink, {
                      href: _ctx.route('register'),
                      class: "inertia-link text text--less-gap text--primary-b text--size-16 text--center"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$trans("auth.register")), 1)
                      ]),
                      _: 1
                    }, 8, ["href"])
                  ])
                ])
              ])
            ], 32)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
})